<template>
    <WindowLayout :title="title">
        <div class="row">
            <div class="col-sm-12">
                <div class="darmin card">
                    <div class="card-header pb-0">
                        <h5>{{ headerTitle }}</h5>
                        <div>{{ state.id }}</div>
                    </div>
                    <div class="card-body theme-form">
                        <div class="row">
                            <div class="col">
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Nombre</label>
                                    <div class="col-sm-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="state.name"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Parent</label>
                                    <div class="col-sm-9">
                                        <treeselect
                                            v-model="state.category"
                                            :options="categories"
                                        ></treeselect>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Estado</label>
                                    <div class="col-sm-9">
                                        <treeselect
                                            v-model="state.status"
                                            :options="[
                                                { id: '1', label: 'Activo' },
                                                { id: '0', label: 'Inactivo' },
                                            ]"
                                        ></treeselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="darmin card header-card">
                    <div class="row">
                        <div class="col-12 text-end">
                            <div class="btn btn-primary ms-auto" @click="handleAction">
                                <i class="far fa-save"></i>
                                Guardar
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </WindowLayout>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { defineComponent, onBeforeMount, onMounted, reactive, computed, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useSnackbar } from 'vue3-snackbar';
import axios from '@/services/useAxios';
import Treeselect from 'vue3-treeselect';
import WindowLayout from '@/layouts/Window.layout.vue';
// import SelectInputSimpleState from '@/components/form/SelectInputSimpleState.vue';
// import SelectInput from '@/components/form/SelectInput.vue';

export default defineComponent({
    name: 'PermissionCategoryForm',
    components: {
        WindowLayout,
        // SelectInputSimpleState,
        // SelectInput,
        Treeselect,
    },
    props: {
        title: { type: String, default: 'Permisos de Usuario' },
        headerTitle: { type: String, default: 'Crear perfil' },
        urlRead: { type: String, required: true },
        urlCreate: { type: String, required: false },
        urlUpdate: { type: String, required: false },
        item: Object,
    },
    setup(props) {
        const snackbar = useSnackbar();
        const categories = ref([]);
        const state = reactive({
            id: '',
            name: '',
            category: null,
            status: '1',
        });

        const rules = computed(() => ({
            name: { required },
            status: { required },
        }));
        const $v = useVuelidate(rules, state);

        onBeforeMount(async () => {
            if (props.item) {
                state.id = props.item.id;
                state.name = props.item.name;
                state.category = props.item.category.id;
                state.status = props.item.status.toString();
            }
        });

        onMounted(async () => {
            const { data } = await axios.get('/users/permission-category/select');
            categories.value = data;
        });

        const handleAction = async () => {
            await $v.value.$validate();
            if (!$v.value.$error) {
                if (props.item) {
                    await axios
                        .put(`${props.urlUpdate || props.urlRead}/${props.item.id}`, {
                            name: state.name,
                            category: state.category,
                            status: Number(state.status),
                        })
                        .then(() => {
                            snackbar.add({
                                type: 'success',
                                text: 'Item ha sido actualizado',
                            });
                        })
                        .catch((error) => {
                            console.log(error);
                            error.data.errors.map((e) => {
                                snackbar.add({
                                    type: 'error',
                                    text: e.msg,
                                });
                                return true;
                            });
                        });
                } else {
                    await axios
                        .post(props.urlCreate || props.urlRead, {
                            name: state.name,
                            category: state.category,
                            status: Number(state.status),
                        })
                        .then(async () => {
                            snackbar.add({
                                type: 'success',
                                text: 'Item ha sido agregado',
                            });
                            state.name = '';
                            state.category = null;
                            state.status = '1';
                        })
                        .catch((error) => {
                            console.log(error);
                            error.data.errors.map((e) => {
                                snackbar.add({
                                    type: 'error',
                                    text: e.msg,
                                });
                                return true;
                            });
                        });
                }
            } else {
                console.log($v.value.$errors);
            }
        };
        return { state, handleAction, categories };
    },
});
</script>

<style></style>
